import React, { Fragment } from 'react'

import { ListItem, ListItemText } from '@material-ui/core'

const DefaultItemList = ({ itemList, itemClicked, currentItems }) => {
  const display = itemList.map(item => (
    <ListItem
      key={item.item_id}
      onClick={() => itemClicked(item)}
      selected={!!currentItems.includes(+item.item_id)}>
      <ListItemText>
        {item.item_code ? `${item.item_code} - ${item.item_name}` : item.item_name}
      </ListItemText>
    </ListItem>
  ))
  return <Fragment>{display}</Fragment>
}

export default DefaultItemList
